module.exports = __webpack_public_path__ + "34bc775d/img/placeholder.888fcd0b.svg";